import {Environment, getEnvironment} from '@/services/infrastructure/envhelper.service'
import {TogglableFeature} from '@/feature-toggles/feature-toggler.service'

export const MultiCreateFeature: TogglableFeature = {
    isEnabled: () => {
        return getEnvironment() === Environment.Local
    }
}